// extracted by mini-css-extract-plugin
module.exports = {"container":"NoCardsDialogContent_container__KmhHq","actions":"NoCardsDialogContent_actions__2hllv","confirm":"NoCardsDialogContent_confirm__36YsM"};